/**
 * Shared verdict badge — the one place color is used (green Yes / red No),
 * from the theme's semantic Badge variants.
 */

import { Check, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { SentinelVerdict } from "@/services/sentinelReview.service";

export function VerdictBadge({ verdict }: { verdict: SentinelVerdict }) {
  const isYes = verdict === "yes";
  return (
    <Badge variant={isYes ? "success" : "destructive"} className="shrink-0 gap-1 font-normal">
      {isYes ? <Check className="size-3" /> : <X className="size-3" />}
      {isYes ? "Yes" : "No"}
    </Badge>
  );
}
